import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly11B2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/class-assembly/11B/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/class-assembly/11B/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/class-assembly/11B/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/class-assembly/11B/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/class-assembly/11B/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/class-assembly/11B/6.webp`;

  const photos = [
    { src: p1, source: p1, rows: 1, cols: 1 },
    { src: p2, source: p2, rows: 1, cols: 1 },
    { src: p3, source: p3, rows: 1, cols: 1 },
    { src: p4, source: p4, rows: 1, cols: 1 },
    { src: p5, source: p5, rows: 1, cols: 1 },
    { src: p6, source: p6, rows: 1, cols: 1 },

  ];

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                <Typography variant="h4" align="center">
                ‘Operation Honest India: A Humorous Dance Drama’.
                </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  Class: 11 B   Date: 6,7 & 8 August 2026
                </Typography>

<Typography variant={'subtitle1'} align={'justify'}>
Students of Class 11 B presented a captivating assembly on the theme ‘Operation Honest India: A
Humorous Dance Drama’. The focus of the presentation was on eradicating bureaucratic corruption and
promoting citizen integrity. The assembly began with an engaging scene depicting a common citizen's
struggle through a chaotic office maze, setting a relatable and humorous tone. This was followed by a
series of dynamic performances — including a satirical skit, political parodies, a digital robot
demonstration and an energetic dance sequence — that brought alive the spirit of transparency,
responsibility and civic duty.
  <br></br>
  The dramatic act highlighted the emergence of the corruption monster ‘Bhrashtasur’ and his defeat
through unified action and modern digital solutions. The students beautifully conveyed the timeless
values of service, honesty and individual accountability through their creative placards and dialogues.
  <br></br>
  The assembly concluded with the message that a corruption-free India is built by everyday honest
citizens making responsible choices rather than relying solely on laws. The assembly left a lasting
impression on the audience and was deeply appreciated by all.
  <br></br>
 
</Typography>
              </Box>

            <Typography
                variant="h6"
                 color="primary"
                 align="center"
                 fontWeight="normal">
                <br />
            "Integrity is doing the right thing, even when no one is watching." — C.S. Lewis
                 <br />
            </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 10E 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>

              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly11B2026;
